import * as actionCreators from '../state/actionCreators'
import { define } from "../../../utils/typeUtils"
import { useFind } from "../../../state/reducers/hooks"
import { TableName } from "../../../tables"
import { ProductsState } from "../state/reducer"
import { useSelector } from "react-redux"
import { State } from "../../../state"
import { bindActionCreators } from "redux"
import { useDispatch } from "react-redux"
import { usePricesHooks } from "../../operations"
import { CustomerType, useSalesState } from "../../sales"
import { useAdministrationState } from "../../administration"
import { PriceItem } from "./types"

export const useProductsState = (): ProductsState => useSelector((state: State) => state.productsReducer)

export const useProductsStateActions = () => bindActionCreators(actionCreators, useDispatch())

export const useProductsHooks = () => {
    const { paymentTypes } = useAdministrationState()
    const { customerTypes } = useSalesState()

    const pricesHooks = usePricesHooks()
    const find = useFind()

    const getPriceList = (productId: string): PriceItem[] => {
        const list: PriceItem[] = []
        paymentTypes.forEach(paymentType => {
            customerTypes.forEach(customerType => {
                const price = pricesHooks.product.adjustedPrice(productId, false, customerType.id, paymentType.id)
                list.push({
                    customerTypeId: customerType.id,
                    paymentTypeId: paymentType.id,
                    price
                })
            })
        })

        const findCustomerType = (id: string) => define(find(TableName.CUSTOMER_TYPES, id)) as CustomerType

        const salePriceList = list.sort((a, b) => {
            const customerTypeA = findCustomerType(a.customerTypeId)
            const customerTypeB = findCustomerType(b.customerTypeId)
            if (customerTypeA.name < customerTypeB.name) return -1
            if (customerTypeA.name > customerTypeB.name) return 1
            return a.price - b.price
        })
        return salePriceList
    }

    return {
        getPriceList
    }
}
